import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const AdvancedProductBkg2Svg = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='761'
    height='282'
    viewBox='0 0 761 282'
    fill='none'
  >
    <path
      d='M760.824 10.813C760.824 5.29015 756.347 0.812988 750.824 0.812988H10.8237C5.3009 0.812988 0.82373 5.29014 0.82373 10.813V123.384L760.824 281.986V10.813Z'
      fill='url(#paint0_linear_368_9608)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_368_9608'
        x1='760.824'
        y1='0.812988'
        x2='200.317'
        y2='504.142'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#EDDDFC' />
        <stop offset='1' stopColor='#FFECD9' />
      </linearGradient>
    </defs>
  </svg>
);

export const AdvancedProductBkg2Icon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={AdvancedProductBkg2Svg} {...props} />
);
